import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Alert, Box } from '@mui/material';

import api from '../../views/services/api';

// Tarja de aviso (mesmo padrão visual do `PlanExpirationBanner`) pro admin
// quando o canal WhatsApp w-api já está configurado (credenciais
// preenchidas) mas a sessão caiu - precisa reconectar escaneando o QR code
// de novo (ver `conversas/views.py::whatsapp_w_api_connection_alert`).
// Diferente do aviso de plano, dá pra fechar - guardado em sessionStorage
// pra não voltar a cada F5 na mesma aba, mas reaparece numa aba/sessão
// nova (ou se a desconexão ainda persistir depois de um tempo).
const SESSION_STORAGE_PREFIX = 'whatsapp_w_api_banner_fechado_';

const WhatsappWApiConnectionBanner = () => {
    const user = useSelector((state) => state.account.user);
    const [integrationId, setIntegrationId] = useState(null);
    const [fechado, setFechado] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (!user || user.role !== 'admin') return;

        (async () => {
            try {
                const resApp = await api.get('v1/apps/default/');
                const appId = resApp.data?.app?.id;
                if (!appId) return;

                const resAlerta = await api.get(`v1/apps/${appId}/integrations/w_api_connection_alert/`);
                if (resAlerta.data?.desconectado) {
                    const id = resAlerta.data.integration_id;
                    setIntegrationId(id);
                    try {
                        if (sessionStorage.getItem(`${SESSION_STORAGE_PREFIX}${id}`)) {
                            setFechado(true);
                        }
                    } catch (e) {
                        // sessionStorage pode falhar (aba anônima, bloqueio de site) - sem problema, só não lembra o "fechado".
                    }
                }
            } catch (error) {
                console.error('Erro ao checar conexão do WhatsApp w-api:', error);
            }
        })();
    }, [user]);

    if (!user || user.role !== 'admin' || !integrationId || fechado) {
        return null;
    }

    const handleFechar = () => {
        setFechado(true);
        try {
            sessionStorage.setItem(`${SESSION_STORAGE_PREFIX}${integrationId}`, '1');
        } catch (e) {
            // sem problema se não conseguir persistir - só não lembra na próxima vez
        }
    };

    return (
        <Alert severity="warning" onClose={handleFechar} sx={{ mb: 2, '& .MuiAlert-message': { fontWeight: 500 } }}>
            <Box component="span" sx={{ cursor: 'pointer' }} onClick={() => history.push('/dashboard/admin/channels')}>
                O canal de mensagem WhatsApp não está conectado. Clique aqui para concluir a conexão.
            </Box>
        </Alert>
    );
};

export default WhatsappWApiConnectionBanner;
